import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const config = {
  // Backend API Configuration
  baseURL: '/api',
  
  // Environment
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production'
};

// Export baseQuery for Redux services
export const baseQuery = fetchBaseQuery({
  baseUrl: config.baseURL,
});

console.log("🔧 process.env dump:", process.env);

console.log("🌍 ENV Debug:");
console.log("REACT_APP_BASE_URL =", process.env.REACT_APP_BASE_URL);

// Debug: Log the config values
console.log("🔧 Config Debug:");
console.log("  - process.env.REACT_APP_BASE_URL:", process.env.REACT_APP_BASE_URL);
console.log("  - window.location.origin:", window.location.origin);
console.log("  - config.baseURL:", config.baseURL);

export default config;
